import type { FloorplanEvent, FloorplanSnapshot, FloorplanState } from './types.js';

// Pure reducer. Returns same reference on no-op transitions so dispatch
// can short-circuit equality. degenerateCalibration is treated as
// immutable input — the orchestrator sets it once at scene-load and the
// reducer never mutates it.
export function floorplanTransition(state: FloorplanState, event: FloorplanEvent): FloorplanState {
  switch (event.type) {
    case 'TOGGLE_VISIBILITY':
      return { ...state, visible: !state.visible };
    case 'CLOSE':
      if (!state.visible) return state;
      return { ...state, visible: false };
    case 'IMAGE_ERROR':
      if (state.imageError) return state;
      return { ...state, imageError: true };
  }
}

export function floorplanSnapshot(state: FloorplanState): FloorplanSnapshot {
  return {
    visible: state.visible,
    imageError: state.imageError,
    degenerateCalibration: state.degenerateCalibration,
  };
}
